import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IAcademicInfo } from "../../models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AcademicInfoService {
  constructor(private http: HttpClient) {}

  getAcademicInfo = (): Observable<IAcademicInfo> => {
    return this.http.get(
      `${environment.apiUrl}/getAcademicInformation`
    ) as Observable<IAcademicInfo>;
  };

  postAcademicInfo = (
    academicInfo: IAcademicInfo
  ): Observable<IAcademicInfo> => {
    return this.http.post(
      `${environment.apiUrl}/AddAcademicInformation`,
      academicInfo
    ) as Observable<IAcademicInfo>;
  };

  checkIfApplicantProgramConfig(appId) {
    return this.http.get(
      `${environment.apiUrl}/checkIfApplicantProgramConfig/?appId=${appId}`
    );
  }

  checkIfAESubmitted(appId) {
    return this.http.get(
      `${environment.apiUrl}/checkIfAESubmitted/?appId=${appId}`
    );
  }

  setAutoEval(appId) {
    return this.http.post(`${environment.apiUrl}/setAutoEval`, {
      Application_Id: appId,
    });
  }

  getGuid(appId) {
    return this.http.get(`${environment.apiUrl}/getGuid?appId=${appId}`);
  }
}
